import createArray from '../helpers/array_helper.js'

export default function MatrixBodyFacade(params) {
    var self = null;
    var data = {};
    var win = null;
    var body = null;
    var wrapper = null;
    var loadingWidget = null;
    var mechanic = null;
    var defaults = {
        bodySelector: ".matrix_body",
        wrapperSelector: ".body_wrapper",
        holderSelector: ".inner_holder",
        loadingSelector: ".loader_wrapper",
        m: 3,
        n: 3
    };;

    var onLoadRunnables = [];
    var onResizeRunnables = [];
    var listeners = [];

    var holders = [];
    var holderMatrix = []; // double-array

    var m = 3;
    var n = 3;

    this.getM = function() {
        return m;
    }

    this.getN = function() {
        return n;
    }

    this.getMechanic = function() {
        return mechanic;
    }

    this.getWindow = function() {
        return win;
    }

    this.getBody = function() {
        return body;
    }

    this.getWrapper = function() {
        return wrapper;
    }

    this.getData = function() {
        return data;
    }

    this.addListener = function(l) {
        listeners.push(l);
    }

    this.removeListener = function(l) {
        listeners.removeItem(l);
    }

    this.addHiddenWhenLoadingElement = function(e) {
        loadingWidget.addDependent($(e));
    }

    this.removeHiddenWhenLoadingElement = function(e) {
        loadingWidget.removeDependent(e);
    }

    this.getLoadingWidget = function() {
        return loadingWidget;
    }

    this.isLoading = function() {
        return loadingWidget.isLoading();
    }

    this.setLoading = function(l) {
        loadingWidget.setLoading(l);
    }

    this.onLoad = function(l) {
        onLoadRunnables.push(l);
    }

    this.onResize = function(l) {
        onResizeRunnables.push(l);
    }

    this.setMechanic = function(m) {
        if (m == null)
            return;

        mechanic = m;

        body.attr("data-center-i", m.getCenter().i);
        body.attr("data-center-j", m.getCenter().j);

        mechanic.setFacade(self);
    }

    this.getHolders = function() {
        return holders;
    }

    this.getHolder = function(i,j) {
        if (i >= n || j >= m)
            return null;

        if (i < 0 || j < 0)
            return null;

        return holderMatrix[i][j];
    }

    this.findHolder = function(identifier) {
        var target = null;

        holders.forEach(function(vh) {
            if (vh.getIdentifier() == identifier)
                target = vh;
        });

        return target;
    }

    this.addHolder = function(h, i, j) {
        var holderIsSomewhere = self.findHolder(h.getIdentifier()) != null;
        var slotIsEmpty = holderMatrix[i][j] == null || holderMatrix[i][j].getBuilder().getType() == "empty";

        if (holderMatrix[i][j] == null || (!holderIsSomewhere && slotIsEmpty)) {
            h.create();
            h.set(i, j);
            holders.push(h);

            if (holderMatrix[i][j] != null) {
                holderMatrix[i][j].getElement().after(h.getElement());

                holderMatrix[i][j].getElement().remove();

                holderMatrix[i][j].set(null, null);
                holders.removeItem(holderMatrix[i][j]);
            } else {
                body.append(h.getElement());
            }

            holderMatrix[i][j] = h;

            h.didAttachToWindow(self);

            if (mechanic != null && i == mechanic.getCenter().i && j == mechanic.getCenter().j)
                mechanic.goCenter();
        }
    }
    
    this.replaceWithEmptyHolder = function(h, i ,j, shouldCreateEmpty) {
        var holderIsSomewhere = self.findHolder(h.getIdentifier()) != null;
        var slotIsEmpty = holderMatrix[i][j] == null || holderMatrix[i][j].getBuilder().getType() == "empty";
        var shouldCreate = true && !!shouldCreateEmpty
        if ((h != null && h.getBuilder().getType() != "empty") && (!holderIsSomewhere || slotIsEmpty))
            return;
    
        h.getElement().remove();
    
        h.set(null, null);
    
        h.unload();
    
        holderMatrix[i][j] = null;
        holders.removeItem(h);
    
        if (shouldCreate)
            self.addHolder(createEmptyInnerHolderAt(i, j), i, j);
    }
    
    this.removeHolder = function(h, i ,j) {
        self.replaceWithEmptyHolder(h, i, j, false);
    }

    var createEmptyInnerHolderAt = function(i, j) {
        var emptyId = "empty_{i}_{j}".format({i: i, j: j});

        return new MatrixInnerHolderComponent({
            identifier: emptyId + "_ihc",
            containerSelector: "." + emptyId + ".empty_inner_holder.inner_holder",
            contentSelector: ".empty_inner_holder_container_wrapper.inner_holder_container_wrapper",
            builder: new EmptyMatrixInnerHolderBuilder()
        });
    }
    
    this.reset = function (pa) {
        body.html("");
        holders = []
        
        self.init(self, pa);
    }

    this.init = function(that, pa) {
        self = that;
        defaults = Object.assign(defaults, pa);
        win = $(window);
        body = $(defaults.bodySelector);
        wrapper = $(defaults.wrapperSelector);
        loadingWidget = new LoadingWidget(defaults.loadingSelector);
        holders = [];
        
        m = defaults.m;
        n = defaults.n;
        holderMatrix = createArray(n, m);
    
        body.attr("data-m", m);
        body.attr("data-n", n);
        
        for (var i = 0; i < n; i++) {
            for (var j = 0; j < m; j++) {
                self.addHolder(createEmptyInnerHolderAt(i, j), i, j);
            }
        }
    
        win.on('load', function () {
            onLoadRunnables.forEach(function (f) {
                f(self, win);
            });
        });
    
        /* pega esse monster pra redimensionar matriz no resize */
        var id = null;
        var widthMemento = win.width();
        win.on('resize', function () {
            if (id != null)
                clearInterval(id);
        
            var stretching = win.width() > widthMemento;
            widthMemento = win.width();
        
            id = setInterval(function () {
                var mec = self.getMechanic();
                var mementoI = mec.getCurrent().getI();
                var mementoJ = mec.getCurrent().getJ();
            
                if (stretching)
                    mec.go(0, 0, 0);
                else
                    mec.go(n - 1, m - 1, 0);
            
                setTimeout(function () {
                    mec.go(mementoI, mementoJ, 0);
                
                    clearInterval(id);
                }, 100);
    
                mec.updateControls(self, mec.getCurrent());
            }, 300);
        })
    }
    
    var __construct = function(that) {
        that.init(that, params);
    }(this)
}


